import React from 'react'
import { BsChevronBarRight, BsChevronRight, BsChevronBarLeft, BsChevronLeft } from 'react-icons/bs'

import { Container, NavigationButtons, PageNumber } from './styles'

interface PaginationProps {
  page: number
  total_pages: number
  toPreviousPage(): void
  toNextPage(): void
  toFirstPage(): void
  toLastPage(): void
  toPage(page: number): void
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  total_pages,
  toFirstPage,
  toPreviousPage,
  toNextPage,
  toLastPage,
  toPage,
}) => {
  return (
    <Container>
      <NavigationButtons aria-label="Primeira página" onClick={toFirstPage} disabled={page === 1}>
        <BsChevronBarLeft />
      </NavigationButtons>
      <NavigationButtons aria-label="Anterior" onClick={toPreviousPage} disabled={page === 1}>
        <BsChevronLeft />
      </NavigationButtons>
      {page - 2 > 0 && page === total_pages && (
        <PageNumber onClick={() => toPage(page - 2)}>{page - 2}</PageNumber>
      )}
      {page > 1 && <PageNumber onClick={() => toPage(page - 1)}>{page - 1}</PageNumber>}
      <PageNumber disabled select>
        {page}
      </PageNumber>
      {page < total_pages && <PageNumber onClick={() => toPage(page + 1)}>{page + 1}</PageNumber>}
      {page + 2 < total_pages && page === 1 && (
        <PageNumber onClick={() => toPage(page + 2)}>{page + 2}</PageNumber>
      )}
      <NavigationButtons aria-label="Próxima" onClick={toNextPage} disabled={page === total_pages}>
        <BsChevronRight />
      </NavigationButtons>
      <NavigationButtons
        aria-label="Última página"
        onClick={toLastPage}
        disabled={page === total_pages}
      >
        <BsChevronBarRight />
      </NavigationButtons>
    </Container>
  )
}

export default Pagination
